import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { list_url } from "@project/sharedcomponents/apiURL"
import { removeDrawer } from "./CommonActionsV2"
import {
  GSTMYSTORE_USER_SEARCH_TEXT_UPDATE,
  GSTMYSTORE_USER_SERVICE_CLEAR,
  GSTMYSTORE_USER_SERVICE_FAIL,
  GSTMYSTORE_USER_SERVICE_START,
  GSTMYSTORE_USER_SERVICE_SUCCESS,
  LAST_PAGE_UPDATE,
  LOADING_STATE,
  SNACKBAR_STATE,
} from "./types"
import { getAccountSitesetting, getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"

export const getmystoreUser_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: GSTMYSTORE_USER_SERVICE_CLEAR,
    })
  }
}
export const getmystoreUsersearch_change = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: GSTMYSTORE_USER_SEARCH_TEXT_UPDATE,
      search_text: search_text,
    })
  }
}
export const fetch_getmystoreUser_data = ({ companycode, rowsPerPage, page, order, orderBy, search_text, other_type, functions }) => {
  const pagination_size = getAccountSitesetting("pagination_size")
  if (isblank(rowsPerPage)) {
    rowsPerPage = pagination_size
  }
  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: GSTMYSTORE_USER_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })
    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "catalogueList")
    data.append("limit", rowsPerPage)
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    data.append("other_type", other_type)
    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "catalogueList" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          getmystoreUserServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          getmystoreUserServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          dispatch({
            type: LAST_PAGE_UPDATE,
            lasttype: "getmystoreUser",
            lastaction: "list",
            lasttime: new Date().getTime(),
            lastdata: "",
          })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          getmystoreUserServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

export const setGetMyStoreNotification = ({ title, body, flag, functions }) => {
  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: LOADING_STATE, sidebarstate: true })
    let data = new FormData()
    data.append("title", title)
    data.append("body", body)
    data.append("flag", flag)

    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "setGetMyStoreNotf" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          dispatch({
            type: SNACKBAR_STATE,
            payload: true,
            message: response.data.meta.message,
            snackbarType: "error",
          })
          dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
        } else {
          dispatch({
            type: SNACKBAR_STATE,
            payload: true,
            message: response.data.meta.message,
            snackbarType: "success",
          })
          removeDrawer(dispatch)
          dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
        } else {
          postErrorOnException(error)
          dispatch({
            type: SNACKBAR_STATE,
            payload: true,
            message: getCatchErrorMessage(error),
            snackbarType: "error",
          })

          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const getmystoreUserServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: GSTMYSTORE_USER_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

const getmystoreUserServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: GSTMYSTORE_USER_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
